import { apiClient } from '../api.client';
import type { User } from '../../types/auth';
import type { IUserService } from '../interfaces/IUserService';

export const userReal: IUserService = {
  getProfile: () => apiClient.get<User>('/users/me'),

  updateProfile: (data) => apiClient.patch<User>('/users/me', data),

  changePassword: (currentPassword, newPassword) =>
    apiClient.post<void>('/users/me/change-password', {
      currentPassword,
      newPassword,
    }),

  uploadAvatar: (file: File) => {
    const form = new FormData();
    form.append('avatar', file);
    return apiClient.postForm<{ avatarUrl: string }>('/users/me/avatar', form);
  },

  deleteAccount: () => apiClient.delete<void>('/users/me'),
};
